import { registerService } from "@/api";
import { setTokenCookie, setEntranceKeyCookie } from "@/utils/cookie";

const state = {
  token: localStorage.getItem("token"),
  info:
    localStorage.getItem("user-info") &&
    JSON.parse(localStorage.getItem("user-info")),
  avatar:
    localStorage.getItem("user-info") &&
    JSON.parse(localStorage.getItem("user-info")).avatar,
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INFO(state, info) {
    state.info = info;
  },
  SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
};

const actions = {
  setToken({ commit }, token) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", token);

      localStorage.setItem("token", token);

      setTokenCookie(token);
      setEntranceKeyCookie();

      resolve();
    });
  },
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      registerService
        .getUserInfo()
        .then((res) => {
          const { data } = res;

          commit("SET_INFO", data);

          commit("SET_AVATAR", data.avatar);

          localStorage.setItem("user-info", JSON.stringify(data));

          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
